import intl from 'react-intl-universal'

export default {
  type: 'correction',
  title: `Correction`,
  icon: `fire-extinguisher`,
  template: `
        <div
          contenteditable="false"
          feature-obj="feature"
          org-index="orgIndex"
          class="">
            <h4 hidden
              class="my-0"
              contenteditable="false"
              class="text-muted">
                correction:
            </h4>
          <p
            class="px-2 pb-2"
            contenteditable="false"><span class="text-capitalize">{{feature.correction_type || ${intl.get(
              'blocks.correction.unknownType'
            )}}}</span> : <em>{{feature.text}}</em></p>
        </div>`,
  propertyTemplate: `<div class="form-group row">
              <label>correction type</label>
                <select ng-model="feature.correction_type">
                  <option ng-repeat="opt in correctionTypes">{{opt}}</option>
                </select>
            </div>
            <div class="form-group row">
              <label>correction text</label>
              <textarea
                class="form-control"
                smart-quote-handler
                ng-model="feature.text"
                placeholder="">
              </textarea>
            </div>`,
  initialInflation: function () {
    return {
      type: 'correction',
      correction_type: '',
      text: '',
    }
  },
  openPropertyTemplateOnAdd: true,
}
